<template>
  <div id="app">
    <yd-layout>
      <!-- <yd-navbar slot="navbar" :title="title" v-if="isShowTopNav">
        <yd-navbar-back-icon></yd-navbar-back-icon>
      </yd-navbar> -->
      <van-nav-bar
        left-arrow
        @click-left="onClickLeft"
        v-if="isShowTopNav"
        style="flex-shrink: 0"
      />
      <div
        class="container"
        :style="{ paddingBottom: isShowTabbar ? '50px' : 0 }"
      >
        <router-view />
      </div>
      <yd-tabbar slot="tabbar" v-if="isShowTabbar" padding="4px">
        <yd-tabbar-item
          v-for="(t, index) in tabbar"
          :key="index"
          :title="t.title"
          :link="t.path + '?iid=' + $route.query.iid"
          :active="$route.path === t.path"
        >
          <yd-icon :name="t.iconName" slot="icon" size=".4rem" custom></yd-icon>
        </yd-tabbar-item>
      </yd-tabbar>
    </yd-layout>
  </div>
</template>

<script>
import appService from "@/services/request/appService";
import wechatService from "@/services/request/wechatService";
import store from "store";
import { NavBar } from "vant";
export default {
  name: "MainAppBase",
  components: { NavBar },
  data() {
    return {
      isShowTopNav: true,
      isShowTabbar: false,
      title: "",
      mine: {},
      tabbar: [
        {
          title: "线路",
          iconName: "yunfuwuqi",
          path: "/m/a/list",
        },
        {
          title: "我的",
          iconName: "hezuohuobanmiyueguanli",
          path: "/m/personal/index",
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      let thisPage = to.name;
      if (
        thisPage === "ActivityList" ||
        thisPage === "ScheduleIndex" ||
        thisPage === "PersonalIndex" ||
        thisPage === "SalerIndex" ||
        thisPage === "BigDataIndex"
      ) {
        if (this.$route.query.noTab) {
          this.isShowTabbar = false;
        } else {
          this.isShowTabbar = true;
        }
      } else {
        this.isShowTabbar = false;
      }
      // this.isShowTopNav = true
      console.log("thisPage", thisPage);
      if (
        thisPage == "PersonalIndex" ||
        thisPage == "BigDataIndex" ||
        thisPage == "SalerIndex" ||
        thisPage == "ScheduleIndex" ||
        thisPage == "ActivityList" ||
        thisPage == "ActivityDetail"
      ) {
        this.isShowTopNav = false;
      } else {
        this.isShowTopNav = true;
      }

      if (this.$route.query.needBack) {
        this.isShowTopNav = true;
      }
    },
  },
  created() {
    if (this.$page.isInWechat) {
      this.wechatInit();
    }
  },
  mounted: function () {
    console.log(this.$route);
    this.title = document.title;
    this.$nextTick(function () {
      if (
        this.$route.name == "PersonalIndex" ||
        this.$route.name == "BigDataIndex" ||
        this.$route.name == "SalerIndex" ||
        this.$route.name == "ScheduleIndex" ||
        this.$route.name == "ActivityList" ||
        this.$route.name == "ActivityDetail"
      ) {
        this.isShowTopNav = false;
      }
      if (this.$route.query.needBack) {
        this.isShowTopNav = true;
      }
      var path = window.location.href;
      if (
        path.indexOf("/m/a/list") != -1 ||
        path.indexOf("/m/schedule/index") != -1 ||
        path.indexOf("/m/personal/index") != -1 ||
        path.indexOf("/m/bigdata/index") != -1
      ) {
        if (this.$route.query.noTab) {
          this.isShowTabbar = false;
        } else {
          this.isShowTabbar = true;
        }
      } else {
        this.isShowTabbar = false;
      }
      if (false) {
        console.log("mine,", store.get("mine"));
        this.mine = store.get("mine");
        this.loadPageData();
        this.shareConfig();
      } else {
        // setTimeout(() => {
        // if(store.get('mine')){
        if (this.$page.isInWechat) {
          this.wechatInit(() => {
            this.loadPageData();
            this.shareConfig();
          });
        } else {
          this.loadPageData();
        }

        // this.mine = store.get('mine')
        // this.loadPageData()
        // this.shareConfig()
        // }
        // }, 1000);
      }
    });
  },
  methods: {
    wechatInit(callback) {
      if (this.isRunEnv("wechat")) {
        //在微信
        this.commonWechatInit(this, (data) => {
          this.mine.unionId = data.unionid;
          if (typeof callback === "function") callback();
        });
      } else {
        if (typeof callback === "function") callback();
      }
      // wechatService.auth(
      //   this.$route.query.iid,
      //   ({ openid, unionid, nickname, headimgurl }) => {
      //     if (!!openid && !!unionid) {
      //       this.mine.unionId = unionid;
      //       if (typeof callback === "function") callback();
      //     }
      //   },
      //   false
      // );
    },
    onClickLeft() {
      history.go(-1);
    },
    loadPageData() {
      this.getUserPermissionScope(() => {
        console.log(this.tabbar);
        // if(this.mine.permission > 0 && this.mine.permission != 8 && this.mine.permission != 10) {
        //   var tabItem1 = {
        //     title: "计调",
        //     iconName: "weizhigeshi",
        //     path: "/m/schedule/index",
        //   }
        //   this.tabbar.splice(1,0,tabItem1)
        //   var tabItem2 = {
        //     title: "管理",
        //     iconName: "yunyingzhongxin",
        //     path: "/m/bigdata/index",
        //   }
        //   this.tabbar.splice(2,0,tabItem2)
        // }else if(this.mine.permission > 0 && this.mine.permission == 8 && this.mine.permission != 10){
        //   var tabItem1 = {
        //     title: "计调",
        //     iconName: "weizhigeshi",
        //     path: "/m/schedule/index",
        //   }
        //   this.tabbar.splice(1,0,tabItem1)
        // }
      });
    },
    getUserPermissionScope(callback) {
      if (this.$page.isInWechat) {
        appService
          .getUserIdentity({
            iid: this.$route.query.iid ? this.$route.query.iid : this.mine.iid,
            rid: 0,
            unionId: store.get("loginData")
              ? store.get("loginData").id
              : this.mine.unionId,
          })
          .then(
            (data) => {
              if (data && data.permission) {
                var permissionInfo = data.permission;
                this.mine.permission = permissionInfo.op;
              }
              if (typeof callback === "function") callback();
            },
            (error) => {
              var errorStr = "加载失败";
              if (error && error.msg) {
                errorStr = error.msg;
              } else if (error && error.sub_msg) {
                errorStr = error.sub_msg;
              }
              this.$dialog.toast({
                mes: errorStr,
                timeout: 1500,
                icon: "error",
              });
            }
          );
      } else {
        if (typeof callback === "function") callback();
      }
    },
    shareConfig() {
      if (true) {
        var shareUrl = window.location.href;
        var imageUrl =
          "https://fimage.oss-cn-shenzhen.aliyuncs.com/common/origin/" +
          (this.$route.query.iid ? this.$route.query.iid : this.mine.iid) +
          "_1.png";
        this.wxShareConfig = {
          title: this.mine.iname + "智慧地接",
          desc: "专注互联网地接",
          imgUrl: imageUrl,
          link: shareUrl,
        };
        wechatService.jsapi(
          this.$route.query.iid ? this.$route.query.iid : this.mine.iid,
          this.wxShareConfig,
          ["onMenuShareTimeline", "onMenuShareAppMessage", "chooseWXPay"]
        );
      }
    },
  },
};
</script>

<style lang="less">
@import "../icon/iconfont.css";
#app {
  height: 100%;
  position: relative;
  .container {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
  }
  .yd-tabbar {
    height: 50px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999999999999;
    & /deep/ span {
      line-height: 1;
    }
  }
}
</style>

